import { api } from "@/api";

export async function getUserTimezones(upn: string): Promise<any> {
  const res = await api.timezones(upn);
  return res;
}

export async function saveUserTimezones(payload: any): Promise<any> {
  const res = await api.saveTimezones(payload);
  return res;
}
